import { TypeDataPackage } from 'src/utils/constants/enum';

//SERVICE
export const USER_SERVICE = '/user-service/';
export const DATA_SERVICE = '/data-service/';
export const PAYMENT_SERVICE = 'payment-service/';
export const PAYMENT_SERVICE_V1 = 'payment-service/v1/';
export const TRADE_DATA_SERVICE_V0 = '/trade-service/';
export const TRADE_DATA_SERVICE_V1 = '/trade-service/v1/';
export const TRADE_DATA_SERVICE_PORTAL_V1 = '/trade-service/portal/v1/';
export const AI_LABELING_SERVICE = '/ai-service/';
export const SANCTIONS_SERVICE = '/sanction-service';
export const TARIFFS_SERVICE = '/tariff-service/';
export const REPORT_SERVICE = '/report-service/';

//ENDPOINT URL
export const URL_ENDPOINT = {
  user: {
    users: USER_SERVICE + 'users/',
    utils: USER_SERVICE + 'utils/',
    external: USER_SERVICE + 'external/',
    listUsers: USER_SERVICE + 'users/filter-by-email',
  },
  company: {
    commons: DATA_SERVICE + 'commons/',
    companies: DATA_SERVICE + 'companies/',
    tariffs: DATA_SERVICE + 'tariffs/',
    utils: DATA_SERVICE + 'utils/',
  },
  people: {
    people: DATA_SERVICE + 'people/',
  },
  payment: {
    checkout: PAYMENT_SERVICE + 'payment/',
    plan: PAYMENT_SERVICE + 'plan/',
    creditManagement: PAYMENT_SERVICE + 'credit-management/',
    campaign: PAYMENT_SERVICE + 'campaign/',
    transfer: PAYMENT_SERVICE_V1 + 'bank-transfer/',
    team: {
      manage: PAYMENT_SERVICE_V1 + 'team/manage',
      detail: PAYMENT_SERVICE_V1 + 'team/detail',
      create: PAYMENT_SERVICE_V1 + 'team/create',
      addMember: PAYMENT_SERVICE_V1 + 'team/member/add',
      deleteMember: PAYMENT_SERVICE_V1 + 'team/member/delete',
      leaveGroup: PAYMENT_SERVICE_V1 + 'team/member/leave-group',
      chartsSection: PAYMENT_SERVICE_V1 + 'team/manage/charts-section',
    },
  },
  tradeData: {
    //v0
    hsCode: TRADE_DATA_SERVICE_V0 + 'hscodes',
    hs6: TRADE_DATA_SERVICE_V0 + 'hscodes/hs6',
    ports: TRADE_DATA_SERVICE_V0 + 'ports',
    entity: TRADE_DATA_SERVICE_V0 + 'companies',
    entityDetail: TRADE_DATA_SERVICE_V0 + 'companies/:id',
    hsCodeDetail: TRADE_DATA_SERVICE_V0 + 'hscodes/:id',
    companiesByKeyword: TRADE_DATA_SERVICE_V0 + 'companies/list-by-keyword',
    reportHSCodeSearch: TRADE_DATA_SERVICE_V0 + 'hscodes/ai-report',
    // V1
    transactionsPaymentStatus: TRADE_DATA_SERVICE_V1 + 'transactions/payment-status-by-endpoint',
    transactions: TRADE_DATA_SERVICE_V1 + 'transactions',
    transactionsCount: TRADE_DATA_SERVICE_V1 + 'transactions/count',

    marketAnalyticsChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/chart',
    marketAnalyticsAIExplanation: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/explanation',
    marketAnalyticsTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/table',
    marketAnalyticBuyers: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/buyers',
    marketAnalyticSuppliers: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/suppliers',
    marketAnalyticsWorldMap: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/worldmap',

    supplierCountryWorldMap: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/supplier-countries/worldmap',
    supplierCountryAIExplanation: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/supplier-countries/explanation',
    supplierCountryTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/supplier-countries/table',
    supplierCountryCompany: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/supplier-countries/suppliers',
    buyerCountryWorldMap: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyer-countries/worldmap',
    buyerCountryAIExplanation: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyer-countries/explanation',
    buyerCountryTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyer-countries/table',
    buyerCountryCompany: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyer-countries/buyers',

    portOriginChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/chart',
    portDeliveryChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/chart',
    portOriginTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/table',
    portDeliverTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/table',
    portOriginBuyerList: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/:{port_id}/buyers',
    portDeliveryBuyerList: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/:{port_id}/buyers',
    portOriginSupplierList: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/:{port_id}/suppliers',
    portDeliverySupplierList: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/:{port_id}/suppliers',

    suppliersChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/chart',
    suppliersTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/table',
    suppliersListBuyers: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/:{supplier_id}/buyers',
    buyersChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/chart',
    buyersTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/table',
    buyersListSuppliers: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/:{buyer_id}/suppliers',

    unitPriceSuppliersChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/unit-price/chart',
    unitPriceSuppliersTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/unit-price/table',
    unitPriceBuyersChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/unit-price/chart',
    unitPriceBuyersTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/unit-price/table',

    averageUnitPriceChart: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/unit-price/chart/monthly',
    averageUnitPriceTable: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/unit-price/table/monthly',

    exportMarketAnalytic: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/export',
    exportMarketAnalyticBuyer: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/buyers/export',
    exportMarketAnalyticSupplier: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/market/suppliers/export',
    exportBuyerCountry: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyer-countries/export',
    exportBuyersCountryBuyer: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyer-countries/buyers/export',
    exportSupplierCountry: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/supplier-countries/export',
    exportSuppliersCountrySupplier: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/supplier-countries/suppliers/export',
    exportPortOrigin: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/export',
    exportPortOriginBuyer: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/:id/buyers/export',
    exportPortOriginSupplier: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/export_ports/:id/suppliers/export',
    exportPortDelivery: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/export',
    exportPortDeliveryBuyer: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/:id/buyers/export',
    exportPortDeliverySupplier: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/import_ports/:id/suppliers/export',
    exportBuyer: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/export',
    exportBuyersSupplier: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/buyers/:id/suppliers/export',
    exportSupplier: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/export',
    exportSuppliersBuyer: TRADE_DATA_SERVICE_V1 + 'transactions/analysis/suppliers/:id/buyers/export',
    data_package: {
      [TypeDataPackage.top_20_export_company_in_country]:
        TRADE_DATA_SERVICE_PORTAL_V1 + 'data-package/analysis/companies/export',
      [TypeDataPackage.top_20_import_company_in_country]:
        TRADE_DATA_SERVICE_PORTAL_V1 + 'data-package/analysis/companies/import',
      [TypeDataPackage.top_20_export_product_in_country]:
        TRADE_DATA_SERVICE_PORTAL_V1 + 'data-package/analysis/products/export',
      [TypeDataPackage.top_20_import_product_in_country]:
        TRADE_DATA_SERVICE_PORTAL_V1 + 'data-package/analysis/products/import',
      [TypeDataPackage.top_20_trade_balance_between_2_countries]:
        TRADE_DATA_SERVICE_PORTAL_V1 + 'data-package/analysis/trade-balance',
    },
  },
  companyTradeData: {
    transactionsPaymentStatus: TRADE_DATA_SERVICE_V0 + 'company-transactions/payment-status',
    transactions: TRADE_DATA_SERVICE_V0 + 'company-transactions',
    transactionsCount: TRADE_DATA_SERVICE_V0 + 'company-transactions/count',
    buyer: {
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/list',
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/chart',
      map: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/worldmap',
    },
    supplier: {
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/list',
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/chart',
      map: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/worldmap',
    },
    competitor: {
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/chart',
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/list',
      map: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/worldmap',
    },
    poo: {
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/list',
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/chart',
      map: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/worldmap',
    },
    pod: {
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/list',
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/chart',
      map: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/worldmap',
    },
    analytics: {
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics',
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/chart',
    },
    checkCompanyTradeDataTabIsExist: TRADE_DATA_SERVICE_V0 + 'company-transactions/exist',
    hsCode: {
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/hs-code-analytics/chart',
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/hs-code-analytics/list',
    },
    companyDetail: TRADE_DATA_SERVICE_V0 + 'companies/:id',
    exportListBOLs: TRADE_DATA_SERVICE_V0 + 'company-transactions/export',
  },
  port: {
    ports: TRADE_DATA_SERVICE_V0 + 'ports',
  },
  bookmark: {
    list: DATA_SERVICE + 'bookmark/:type',
    detailBookmark: DATA_SERVICE + 'bookmark/:type/:id',
    detailData: DATA_SERVICE + 'bookmark/:type/data/:data_uuid',
    dataUuid: DATA_SERVICE + 'bookmark/data/uuid',
  },
  aiLabeling: {
    instantHSCodePrediction: AI_LABELING_SERVICE + 'predict/sentence_with_list_data',
    uploadFile: AI_LABELING_SERVICE + 'predict/upload_file',
    mappingField: AI_LABELING_SERVICE + 'predict/map_fields',
    hsCodeDetail: AI_LABELING_SERVICE + 'predict/get_hs_code',
    sentenceHSCodePrediction: AI_LABELING_SERVICE + 'predict',
    sentenceHSCodePredictionAISearch: AI_LABELING_SERVICE + 'predict/ai-search',
    getBulkUploadResult: AI_LABELING_SERVICE + 'predict/view_file_result/:id',
    exportBulkUploadResult: AI_LABELING_SERVICE + 'predict/export_file',
    getHistoryBulkUpload: AI_LABELING_SERVICE + 'predict/get_user_file',
  },
  contribute: {
    listCompany: DATA_SERVICE + 'companies/contributions',
    listPeople: DATA_SERVICE + 'people/contributions',
    detailCompany: DATA_SERVICE + 'companies/contributions/:id',
    detailPeople: DATA_SERVICE + 'people/contributions/:id',
    listNotes: USER_SERVICE + 'users/contribution/:id/notes',
    createCommentNote: USER_SERVICE + 'users/contribution/:data_uuid/notes/:note_id',
    modifyCommentNote: USER_SERVICE + 'users/contribution/:data_uuid/notes/:note_id/comment/:comment_id',
  },
  vessels: TRADE_DATA_SERVICE_V0 + 'vessels',
  sanctions: {
    search: SANCTIONS_SERVICE + '/public/v1/search',
    getDetail: SANCTIONS_SERVICE + '/public/v1/entities/:id',
  },
  public: {
    tariffsAndRules: {
      v1: TARIFFS_SERVICE + 'widget/v1/',
      v2: TARIFFS_SERVICE + 'widget/v2/',
    },
    aiLabeling: {
      sentenceHSCodePrediction: AI_LABELING_SERVICE + 'widget/hs-code-prediction',
    },
  },
  myReport: {
    getTradeDataReport: REPORT_SERVICE + 'v1/trade-data-report',
    createTradeDataReport: REPORT_SERVICE + 'v1/trade-data-report/create',
    printCompanyDetail: REPORT_SERVICE + 'v1/company-due-diligence/print-company-detail',
  },
  tariff: {
    v1: TARIFFS_SERVICE + 'portal/v1/',
    v2: TARIFFS_SERVICE + 'portal/v2/',
  },
  tradeDataWithoutHSCode: {
    analytics: {
      totalBillOfLadingYearly: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/yearly',
      totalBillOfLadingMonthly: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/monthly',
      buyersList: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/buyers',
      suppliersList: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/suppliers',
      export: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/export',
      buyersExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/buyers/export',
      suppliersExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/analytics/suppliers/export',
    },
    bol: {
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions',
    },
    hsCode: {
      chart: TRADE_DATA_SERVICE_V0 + 'company-transactions/hs-code-analytics/chart',
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/hs-code-analytics/list',
      export: TRADE_DATA_SERVICE_V0 + 'company-transactions/hs-code-analytics/export',
    },
    buyerSupplier: {
      buyerWorldMap: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/worldmap',
      buyerChart: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/chart',
      buyerListTable: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/list',
      supplierWorldMap: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/worldmap',
      supplierChart: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/chart',
      supplierListTable: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/list',
      buyerExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/buyers/export',
      supplierExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/suppliers/export',
    },
    portOfOriginPortOfDelivery: {
      POOWorldMap: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/worldmap',
      POOChart: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/chart',
      POOList: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/list',
      PODWorldMap: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/worldmap',
      PODChart: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/chart',
      PODList: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/list',
      POOBuyersList: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/list/{port_code}/buyers',
      POOSuppliersList: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/list/{port_code}/suppliers',
      PODBuyersList: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/list/{port_code}/buyers',
      PODSuppliersList: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/list/{port_code}/suppliers',
      POOExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/export',
      PODExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/export',
      POOBuyersExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/list/:id/buyers/export',
      POOSuppliersExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/export-ports/list/:id/suppliers/export',
      PODBuyersExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/list/:id/buyers/export',
      PODSuppliersExport: TRADE_DATA_SERVICE_V0 + 'company-transactions/import-ports/list/:id/suppliers/export',
    },
    tradingArea: {
      worldMap: TRADE_DATA_SERVICE_V0 + 'company-transactions/trading-countries/worldmap',
      list: TRADE_DATA_SERVICE_V0 + 'company-transactions/trading-countries/list',
      export: TRADE_DATA_SERVICE_V0 + 'company-transactions/trading-countries/export',
    },
    competitor: {
      competitorWorldMap: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/worldmap',
      competitorChart: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/chart',
      competitorList: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/list',
      export: TRADE_DATA_SERVICE_V0 + 'company-transactions/market-share/export',
    },
    checkExist: TRADE_DATA_SERVICE_V0 + 'company-transactions/exist',
  },
};
